module.exports = __webpack_public_path__ + "img/Logo_CleverLAB_sygnet.69605083.png";